<div class="d-flex flex-column main-container">
    <div class="label bold-text">{{ label }}</div>
    <mat-radio-group [(ngModel)]="model" (change)="onChange()">
        @for (option of options; track option) {
            <mat-radio-button [value]="option.id" data-uiid="new-eff-radio-group-option">{{
                option.name
            }}</mat-radio-button>
        }
    </mat-radio-group>
</div>
